export default "__VITE_ASSET__BGOS_Th4__"